"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCirrusResponse = exports.useServiceResponse = exports.useCirrusRealm = void 0;
const react_query_1 = require("react-query");
const useCirrus_1 = require("./useCirrus");
function useCirrusRealm() {
    var _a, _b, _c, _d;
    const res = useServiceResponse();
    return Object.assign(Object.assign({}, res), { data: (_d = (_c = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.serviceDetails) === null || _b === void 0 ? void 0 : _b.list) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.name });
}
exports.useCirrusRealm = useCirrusRealm;
function useServiceResponse() {
    return useCirrusResponse({ messageType: 'ServiceRequest' });
}
exports.useServiceResponse = useServiceResponse;
function useCirrusResponse(request) {
    const { socket } = useCirrus_1.useCirrus();
    return react_query_1.useQuery([socket.id], () => __awaiter(this, void 0, void 0, function* () {
        return yield socket.request(request);
    }));
}
exports.useCirrusResponse = useCirrusResponse;
//# sourceMappingURL=useCirrusRealm.js.map